module.exports = __webpack_public_path__ + "img/LBF_logo.9623a7f2.svg";